import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Response } from '../models/response.models';
import { TenantPractice, AllPracticeMappedStatusListResponse } from '../models/tenant-practice.models';
import { CONTROLLERS, ENDPOINTS } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class TenantPracticeService {
  private controller: string = CONTROLLERS.PRACTICE;

  constructor(private apiService: ApiService) {}

  getPracticeList(): Observable<Response<TenantPractice[]>> {
    return this.apiService.get(
      `${this.controller}/${ENDPOINTS.TENANTS.PRACTICE.GET_PRACTICE_LIST}`
    );
  }

  getPracticeMappedStatus(pmsPracticeIds: string, practiceId: number): Observable<Response<AllPracticeMappedStatusListResponse[]>> {
    const requestBody = {
      PmsPracticeIds: pmsPracticeIds,
      PracticeId: practiceId
    };
    
    return this.apiService.post(
      `${this.controller}/${ENDPOINTS.TENANTS.PRACTICE.GET_MAPPED_STATUS}`,
      requestBody
    );
  }

  resetPractice(practiceId: number): Observable<Response<any>> {
    const requestBody = {
      practiceId,
    };

    return this.apiService.post(
      `${CONTROLLERS.TENANTS.PRACTICE_CONFIGURATION}/${ENDPOINTS.TENANTS.PRACTICE_CONFIGURATION.RESET_PRACTICE}`,
      requestBody
    );
  }
}
